import {ICDRUser} from './_models'

// Employee name is empty when the app does not keep personal data (docs/PERSONAL_DATA.md), then only the number is shown
export const cdrUserLabel = (user: ICDRUser) => (user.name ? `${user.name} (${user.number})` : user.number)
